"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = exports.StorageInstance = void 0;

var _metrics = _interopRequireDefault(require("@adobe/exc-app/metrics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/


var EXPIRE_ON_LOGOUT = 0; // Theshold for storage is 1MB

var THRESHOLD = 1000000;
var compression;

var StorageInstance =
/** @class */
function () {
  function StorageInstance(windowStorage) {
    var _this = this;

    var expirationDict = windowStorage.getItem('shellStorageExpiration');
    this.expirationDict = expirationDict ? JSON.parse(expirationDict) : {};
    this.metrics = _metrics.default.create('exc.storage.Storage');
    this.storage = windowStorage;
    setInterval(function () {
      return _this.trackExpiration();
    }, 60000);
  }
  /**
   * Returns item from storage.
   * @param key Key with which to query storage.
   * @returns Promise which resolves to the value in storage.
   */


  StorageInstance.prototype.get = function (key) {
    return __awaiter(this, void 0, Promise, function () {
      var stringValue, _a, compressed, json, expirationTime, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            stringValue = this.storage.getItem(key);

            if (!stringValue) {
              return [2
              /*return*/
              , null];
            }

            _a = stringValue.split(/\|(.+)/), compressed = _a[0], json = _a[1];

            if (!json) {
              this.remove(key);
              return [2
              /*return*/
              , null];
            }

            expirationTime = this.expirationDict[key]; // If the key has expired, remove it

            if (expirationTime > 0 && expirationTime < Date.now()) {
              this.metrics.event('storage expiration', "Key " + key + " expired at " + expirationTime, {
                expirationTime: expirationTime,
                key: key
              });
              this.remove(key);
              return [2
              /*return*/
              , null];
            }

            if (!(compressed === 'Y')) return [3
            /*break*/
            , 3];
            _b = compression;
            if (_b) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , Promise.resolve().then(() => _interopRequireWildcard(require('./compression')))];

          case 1:
            _b = _c.sent();
            _c.label = 2;

          case 2:
            compression = _b;
            json = compression.decompress(json, key);
            _c.label = 3;

          case 3:
            return [2
            /*return*/
            , JSON.parse(json)];
        }
      });
    });
  };
  /**
   * Returns item expiration time for the key.
   * @param expirationInMs Expiration time to be set.
   * @returns 0 if it expires at logout, or the expiration time.
   */


  StorageInstance.prototype.getExpireTime = function (expirationInMs) {
    return expirationInMs ? Date.now() + expirationInMs : EXPIRE_ON_LOGOUT;
  };
  /**
   * Stores the updated expirationDict in storage.
   */


  StorageInstance.prototype.storeExpirationDictionary = function () {
    try {
      this.storage.setItem('shellStorageExpiration', JSON.stringify(this.expirationDict));
    } catch (domException) {
      this.metrics.error('Failed to set expiration dictionary in storage.', {
        error: domException.name
      });
    }
  };
  /**
   * Updates a key
   * @param key Key with which to query storage.
   * @param value AnyObject Value must be an object of key value pairs.
   * @param expirationInMs Expiration time for the storage entry.
   * @param compress Whether or not to force compress.
   */


  StorageInstance.prototype.update = function (key, value, expirationInMs, compress) {
    return __awaiter(this, void 0, Promise, function () {
      var storedValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.get(key)];

          case 1:
            storedValue = _a.sent();
            storedValue = Object.assign({}, storedValue, value);
            this.set(key, storedValue, expirationInMs, compress);
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Sets a key value pair in browser storage.
   * @param key Key with which to query storage.
   * @param value Value to be put into storage
   * @param expirationInMs Expiration time for the storage entry.
   * @param compress Whether or not to force compress.
   */


  StorageInstance.prototype.set = function (key, value, expirationInMs, compress) {
    return __awaiter(this, void 0, Promise, function () {
      var json, compressed, expirationTimestamp, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            json = JSON.stringify(value);
            compressed = false;
            expirationTimestamp = this.getExpireTime(expirationInMs);
            if (!(json.length > THRESHOLD || compress)) return [3
            /*break*/
            , 3];
            _a = compression;
            if (_a) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , Promise.resolve().then(() => _interopRequireWildcard(require('./compression')))];

          case 1:
            _a = _b.sent();
            _b.label = 2;

          case 2:
            compression = _a;
            json = compression.compress(json, key);
            compressed = true;
            _b.label = 3;

          case 3:
            try {
              this.storage.setItem(key, (compressed ? 'Y' : 'N') + "|" + json);
            } catch (domException) {
              this.metrics.error('Failed to set item in storage.', {
                compressed: compressed,
                error: domException.name,
                key: key,
                rawSize: json.length
              });
            }

            this.storeExpireTime(key, expirationTimestamp);
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Removes item from storage.
   * @param key Key with which to query storage.
   */


  StorageInstance.prototype.remove = function (key) {
    this.storage.removeItem(key);
    delete this.expirationDict[key];
    this.storeExpirationDictionary();
  };
  /**
   * Clears all values or those determined by a filter function.
   * @param filter Function to filter which keys to clear
   */


  StorageInstance.prototype.clear = function (filter) {
    var _this = this;

    Object.keys(this.expirationDict).forEach(function (key) {
      if (!filter || filter(key)) {
        _this.storage.removeItem(key);

        delete _this.expirationDict[key];
      }
    });
    this.storeExpirationDictionary();
  };
  /**
   * Clears values containg an expiration time of 0, denoting that
   * they should be cleared on logout.
   */


  StorageInstance.prototype.clearOnLogout = function () {
    var _this = this;

    this.clear(function (key) {
      return _this.expirationDict[key] === EXPIRE_ON_LOGOUT;
    });
  };
  /**
   * Stores or updates an expiration time for a key.
   * @param key Key with which to query storage.
   * @param expirationTimestamp Expiration timestamp in ms.
   */


  StorageInstance.prototype.storeExpireTime = function (key, expirationTimestamp) {
    this.expirationDict[key] = expirationTimestamp;
    this.storeExpirationDictionary();
  };
  /**
   * Function to check which storage entries have expired and remove them.
   */


  StorageInstance.prototype.trackExpiration = function () {
    var _this = this;

    Object.keys(this.expirationDict).forEach(function (key) {
      var value = _this.expirationDict[key];

      if (value > 0 && value < Date.now()) {
        _this.metrics.event('storage expiration', "Key " + key + " expired at " + value, {
          expirationTime: value,
          key: key
        });

        _this.storage.removeItem(key);

        delete _this.expirationDict[key];
      }
    });
    this.storeExpirationDictionary();
  };

  return StorageInstance;
}();

exports.StorageInstance = StorageInstance;
var local;
var session;

try {
  local = new StorageInstance(localStorage);
  session = new StorageInstance(sessionStorage);
} catch (_a) {
  // Unified Shell will show an error if storage is blocked by the browser.
  // This code is needed to make sure the import of this module does not break execution.
  local = {};
  session = {};
}

var storage = {
  local: local,
  session: session
};
exports.storage = storage;